















import Vue from 'vue'
export default Vue.extend({
  props: {
    value: String,
  },
  data() {
    return {
      showPassword: false,
    }
  },
})
